import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import ApplicationItem from "./ApplicationItem";
import { ApplicationProps } from "./ApplicationItem";
import MisterLogo, { LogoName } from "@rtel/mister-icons/dist/esm/components/MisterLogo";
import MisterIcon from "@rtel/mister-icons/dist/esm/components/MisterIcon";
import { useState } from "react";

export default function ApplicationMenu (props: ApplicationMenuProps){
  const [menu, setMenu] = useState<boolean>(false);
  
    return(
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block w-100 text-center applications-dropdown"
      >
        <DropdownToggle
          className={`btn header-item applications-toggle d-flex ${menu == true ? "active" : ""}`}
          id="page-header-user-dropdown"
          tag="button"
        >
          <MisterLogo name={props.currentActiveApplicationLogoName} isActive={true} />

          <span className="application-title">
            MISTER
            <br />
            <span className="application-text">
              {props.currentActiveApplicationName}
              
              {props.applicationList && props.applicationList?.length > 0 && (
                menu == true ? (
                  <MisterIcon name="ChevronUp" size="sm" />
                ) : (
                  <MisterIcon name="ChevronDown" size="sm" />
                )
              )}
            </span>
          </span>
          </DropdownToggle>
          <DropdownMenu className="app-menu">
            <>
              {props.applicationList?.map((application: ApplicationProps, index: number) =>{
                return(
                  <ApplicationItem key={index} name={application.name} isActive={application.isActive} />
                )
              })}
            </>
        </DropdownMenu>
      </Dropdown>
    )
}

interface ApplicationMenuProps{
    currentActiveApplicationName: string;
    currentActiveApplicationLogoName: LogoName;
    applicationList?: ApplicationProps[];
}